module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_2.a03f5ab1.png";